import React from 'react';
import styled from 'styled-components';
import Icon from './IconFA';

const Wrapper = styled.label`
  border: ${({ borderThickness, borderType, color }) =>
    `${borderThickness}px ${borderType} ${color}`};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  margin: 0;
  padding: 0;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  display: flex;
  align-items: center;
  justify-content: center;
`;

function Checkbox({
  onClick,
  value = false,
  size = 20,
  boxSize = 0,
  iconSize = 0,
  color = 'black',
  borderType = 'solid',
  borderThickness = 1,
  borderRadius = 5,
  wrapperStyle,
  iconStyle,
  ...props
}) {
  return (
    <Wrapper
      onClick={onClick}
      size={boxSize || size + 10}
      color={color}
      borderType={borderType}
      borderRadius={borderRadius}
      borderThickness={borderThickness}
      syle={wrapperStyle}
      {...props}>
      {value && (
        <Icon code="fas fa-check" size={iconSize || size} color={color} style={iconStyle} />
      )}
    </Wrapper>
  );
}

export default Checkbox;
